module.exports = __webpack_public_path__ + "img/collection-diamondJewelryBudgetLow@2x.361975b.webp";